import { useWindowSize } from 'hooks'
import {
  ChartAreaContainer,
  PortfolioTitle,
  SelectDropdownWrapper,
  ChartSkeletonWrapper,
  PortfolioContentWrapper,
} from './styled'

import { ChartWrapper } from './components/portfolio-chart/index'
import React from 'react'

import {
  AllItem,
  SelectBoxWrapper,
  SelectItemWrapper,
  SkeletonWrapper,
} from 'pages/portfolio/styled'
import Skeleton from 'react-loading-skeleton'
import {
  PortfolioCompositionWrapper,
  SkeletonColumn,
  SkeletonRow,
} from './components/composition/style'
export const PortfolioLoading: React.FC = () => {
  const { isMobile, isTablet } = useWindowSize()
  const smallDevice = isMobile || isTablet

  return (
    <PortfolioContentWrapper>
      <PortfolioTitle>Portfolio</PortfolioTitle>
      <ChartAreaContainer>
        <SelectDropdownWrapper>
          <SelectBoxWrapper>
            <SelectItemWrapper isOpen={false}>
              <AllItem>
                <SkeletonWrapper>
                  <Skeleton circle={true} height={24} width={24} />
                </SkeletonWrapper>
                <div>
                  <Skeleton width={180} />
                </div>
              </AllItem>
            </SelectItemWrapper>
          </SelectBoxWrapper>
        </SelectDropdownWrapper>
        <div>
          <ChartWrapper>
            {smallDevice && (
              <div>
                <Skeleton height={125} borderRadius="1.5rem" />
              </div>
            )}
            <ChartSkeletonWrapper>
              <Skeleton height={382} borderRadius="1.5rem" />
            </ChartSkeletonWrapper>
          </ChartWrapper>
        </div>
      </ChartAreaContainer>
      <PortfolioCompositionWrapper className="portfolio-composition">
        <SkeletonColumn>
          <Skeleton height={27} width={180} borderRadius="1.5rem" />
          <SkeletonRow>
            <Skeleton height={24} width={24} borderRadius="50%" />
            <Skeleton height={24} width={isMobile ? 180 : 300} borderRadius="1.5rem" />
          </SkeletonRow>
          <SkeletonRow>
            <Skeleton height={24} width={24} borderRadius="50%" />
            <Skeleton height={24} width={isMobile ? 180 : 300} borderRadius="1.5rem" />
          </SkeletonRow>
        </SkeletonColumn>
      </PortfolioCompositionWrapper>
    </PortfolioContentWrapper>
  )
}

export default PortfolioLoading
